import styled from 'styled-components';

export const FilterAutocomplete = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

export const FilterContainer = styled.div``;

export const FilterIcon = styled.div`
  display: inline-block;
  padding-right: 8px;
  vertical-align: middle;
`;

export const FilterContentContainer = styled.div`
  display: inline-block;
  float: none;
  max-width: 79%;
  vertical-align: middle;
`;

export const FilterName = styled.div`
  font-size: 16px;
`;

export const FilterPhoneNumber = styled.div`
  font-size: 12px;
`;
